<template>
  <div class="dashboard-budget">
    <div class="page-header">
      <div class="page-header-title">
        预算
      </div>
      <div class="page-header-subinfo">
        <!-- <div>
          <i class="iconfont icon-huiyizhihangkanban"></i>会议执行看板
        </div> -->

      </div>
    </div>
    <div class="page-contain">
      <div class="search-content-main">
          <el-form class="search-content-main-fields">
              <el-form-item>
                  <el-select class="search-content-main-fields" placeholder="请选择" v-model="searchMainData.year" @change="handleMainSearch()">
                    <el-option v-for="item in baseDataRecords.Year" :key="item.id" :value="item.id" :label="item.yearName">
                    </el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                  <el-select class="search-content-main-fields" placeholder="请选择" v-model="searchMainData.meetingSystem" @change="handleMainSearch()">
                    <el-option value="" label="全部系统"></el-option>
                    <el-option v-for="item in baseDataRecords.MeetingSystem" :key="item.value" :value="item.value" :label="item.text">
                    </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item>
                  <el-select class="search-content-main-fields" placeholder="请选择" v-model="searchMainData.departId" @change="medicalFieldArr=[''];teamFieldArr=[''];handleMainSearch()">
                    <el-option value="" label="全部部门"></el-option>
                    <el-option v-for="item in baseDataRecords.Depart" :key="item.id" :value="item.id" :label="item.departName">
                    </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item>
                  <el-select filterable multiple class="search-content-main-fields" placeholder="请选择" v-model="medicalFieldArr" @change="teamFieldArr=[''];handleMainSearch()">
                    <el-option value="" label="全部Franchise/DA"></el-option>
                    <el-option v-for="item in getMedicalFieldArray(searchMainData.departId, true)" :key="item.id" :value="item.id" :label="item.medicalFieldName">
                    </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item>
                  <el-select filterable multiple class="search-content-main-fields" placeholder="请选择" v-model="teamFieldArr" @change="handleMainSearch()">
                    <el-option value="" label="全部团队"></el-option>
                    <el-option v-for="item in getTeamArray(searchMainData.departId, medicalFieldArr, true)" :key="item.id" :value="item.id" :label="item.teamName">
                    </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item>
                  <el-select filterable multiple class="search-content-main-fields" placeholder="请选择（可搜索）" v-model="productIdArr" @change="handleMainSearch()">
                    <el-option value="" label="全部产品"></el-option>
                    <el-option v-for="item in baseDataRecords.Product" :key="item.id" :value="item.id" :label="item.productName">
                    </el-option>
                  </el-select>
              </el-form-item>
          </el-form>
        <el-form class="search-content-main-fields">
              <el-form-item>
                  <el-select filterable multiple class="search-content-main-fields" style="width: 0.94rem" placeholder="请选择（可搜索）" v-model="costCenterArr" @change="handleMainSearch()">
                    <el-option value="" label="全部成本中心"></el-option>
                    <el-option v-for="item in baseDataRecords.CostCenter" :key="item.costId" :value="item.costId" :label="item.costId">
                    </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item>
                  <el-select filterable multiple class="search-content-main-fields" style="width: 0.94rem" placeholder="请选择（可搜索）" v-model="wbsCodeArr" @change="handleMainSearch()">
                    <el-option value="" label="全部WBS code"></el-option>
                    <el-option v-for="item in baseDataRecords.WbsCode" :key="item.costId" :value="item.costId" :label="item.costId">
                    </el-option>
                  </el-select>
              </el-form-item>
          </el-form>
      </div>
      <div class="charts-row">
        <div v-show="!onlyBudgetPlan" class="chart chart-small">
          <div class="title"><i class="iconfont icon-nianduyusuanfenpei"></i>年度预算分配</div>
          <div class="gauge-legend">
              <div class="gauge-legend-value gauge-legend-value-1">
                  <div></div>
                  <span>已分配预算</span>
              </div>
              <div class="gauge-legend-value gauge-legend-value-2">
                  <div></div>
                  <span>未分配预算</span>
              </div>
          </div>
          <div class="axis-label">
              <span class="axis-label-0">0</span>
              <span class="axis-label-100">100%</span>
              <span class="axis-label-remain">{{data1Remain+'%'}}</span>
          </div>
          <div>
            <common-echars
              chartClass="chart-class-1"
              :dataset-dimensions="['已分配预算']"
              :dataset-source="data1"
              :option="option1"
              ref="chart1"
            >
            </common-echars>
          </div>
          <div class="message-info">
            <div>
              <div class="message-info-total">年度总预算：{{data1[0]?data1[0].YearBudgetMainSum:0 | ThousandMoneyFormat | MoneyFormat}} K</div>
              <div class="message-info-remain">已分配预算：{{data1[0]?data1[0].YearBudgetDetailSum:0 | ThousandMoneyFormat | MoneyFormat}} K</div>
            </div>
          </div>
        </div>
        <div class="chart" :class="!onlyBudgetPlan?'chart-small':'chart-small-long2'">
          <div class="title"><i class="iconfont icon-nianduyusuanjihua"></i>年度预算计划</div>
          <div class="gauge-legend">
              <div class="gauge-legend-value gauge-legend-value-3">
                  <div></div>
                  <span>已计划预算</span>
              </div>
              <div class="gauge-legend-value gauge-legend-value-2">
                  <div></div>
                  <span>未计划预算</span>
              </div>
          </div>
          <div class="axis-label" :class="!onlyBudgetPlan?'':'axis-label-long'">
              <span class="axis-label-0">0</span>
              <span class="axis-label-100">100%</span>
              <span class="axis-label-remain">{{data2Remain+'%'}}</span>
          </div>
          <div>
            <common-echars
              chartClass="chart-class-2"
              :dataset-dimensions="['已分配预算']"
              :dataset-source="data2"
              :option="option2"
              ref="chart2"
            >
            </common-echars>
          </div>
          <div class="message-info">
            <div>
              <div class="message-info-total">已分配预算：{{data2[0]?data2[0].YearBudgetDetailSum:0 | ThousandMoneyFormat | MoneyFormat}} K</div>
              <div class="message-info-remain">已计划预算：{{data2[0]?data2[0].YearBudgetPlanSum:0 | ThousandMoneyFormat | MoneyFormat}} K</div>
            </div>
          </div>
        </div>
        <div class="chart chart-small-long">
          <div class="title"><i class="iconfont icon-yusuanjindu"></i>预算计划与执行进度</div>
          <div>
            <common-echars
              chartClass="chart-class-3"
              :dataset-dimensions="['进度','已计划预算','已执行金额','待执行预算','计划外预算']"
              :dataset-source="data3"
              :option="option3"
              ref="chart3"
            >
            </common-echars>
          </div>
        </div>
      </div>
      <div class="charts-row">
        <div class="chart">
          <div class="title"><i class="iconfont icon-jiduqushi"></i>预算计划与执行季度趋势</div>
          <div>
            <common-echars
              chartClass="chart-class-4"
              :dataset-dimensions="['季度','已计划','已执行','待执行','计划外','已分配预算']"
              :dataset-source="data4"
              :option="option4"
              ref="chart4"
            >
            </common-echars>
          </div>
        </div>
        <div class="chart">
          <div class="title"><i class="iconfont icon-yueduqushi"></i>预算计划与执行月度趋势</div>
          <div>
            <common-echars
              chartClass="chart-class-5"
              :dataset-dimensions="['月度','已计划','已执行','待执行','计划外']"
              :dataset-source="data5"
              :option="option5"
              ref="chart5"
            >
            </common-echars>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dashboardApi from '@/api/dashboard/index';
import { mapGetters, mapActions } from 'vuex';
import * as orgUtil from '@/util/organizationUtil';
export default {
  data() {
    return {
      medicalFieldArr: [''],
      teamFieldArr: [''],
      productIdArr: [''],
      costCenterArr: [''],
      wbsCodeArr: [''],
      searchMainData: {
        year: '',
        meetingSystem: '',
        departId: '',
        medicalFieldList: '',
        teamFieldList: '',
        productIdList: '',
        costCenterList: '',
        wbsCodeList: '',
      },
      data1Remain: 100,
      data2Remain: 100,
      //1、年度预算分配
      data1: [],
      option1: {
          tooltip: { show:false },
          color: ['#2D82F0'],
          series: [
            {
              type: 'gauge',
              splitNumber: 5,
              progress: {
                show: true,
                width: 18,
              },
              axisLine: {
                lineStyle: {
                  width: 18
                }
              },
              axisTick: {
                show: false
              },
              splitLine: {
                length: 8,
                distance: 0,
                lineStyle: {
                  width: 2,
                  color: '#999'
                }
              },
              axisLabel: {
                show: false
              },
              anchor: {
                show: true,
                showAbove: true,
                size: 14,
                itemStyle: {
                  borderWidth: 0,
                  color: '#2D82F0'
                }
              },
              title: {
                show: false
              },
              detail: {
                valueAnimation: true,
                fontSize: 16,
                color: '#333333',
                offsetCenter: [0, '45%'],
                formatter: function (value) {
                    return value+'%';
                }
              },
            }
          ]
      },
      //2、年度预算分配
      data2: [],
      option2: {
          tooltip: { show:false },
          color: ['#0B41CD'],
          series: [
            {
              type: 'gauge',
              splitNumber: 5,
              progress: {
                show: true,
                width: 18,
              },
              axisLine: {
                lineStyle: {
                  width: 18
                }
              },
              axisTick: {
                show: false
              },
              splitLine: {
                length: 8,
                distance: 0,
                lineStyle: {
                  width: 2,
                  color: '#999'
                }
              },
              axisLabel: {
                show: false
              },
              anchor: {
                show: true,
                showAbove: true,
                size: 14,
                itemStyle: {
                  borderWidth: 0,
                  color: '#0B41CD'
                }
              },
              title: {
                show: false
              },
              detail: {
                valueAnimation: true,
                fontSize: 16,
                color: '#333333',
                offsetCenter: [0, '45%'],
                formatter: function (value) {
                    return value+'%';
                }
              },
            }
          ]
      },
      //3、预算计划与执行进度
      data3: [],
      option3: {
        color:['rgba(11, 65, 205, 0.8)','rgba(11, 65, 205, 0.65)','rgba(11, 65, 205, 0.5)','rgba(11, 65, 205, 0.35)'],
        legend: {
          data: ['已计划预算','已执行金额', '待执行预算','计划外预算'],
          icon: 'rect',
          left: -5,
          itemWidth: 8,
          itemHeight: 8
        },
        tooltip: {
          trigger: 'item' ,
          formatter: this.progressFormater
        },
        xAxis: {axisLabel:{show:false}},
        yAxis: {type: 'category',axisLabel:{show:false}},
        series: [
          {type:'bar',label:{show:true,position:'top',formatter: this.formatValue},name:'已计划预算'},
          {type:'bar',label:{rotate:-10,distance:15, show:true,position:'bottom',formatter: this.formatValue},stack:'detail'},
          {type:'bar',label:{rotate:-10,distance:15, show:true,position:'bottom',formatter: this.formatValue},stack:'detail'},
          {type:'bar',label:{rotate:-10,distance:15, show:true,position:'bottom',formatter: this.formatValue},stack:'detail'},
        ]
      },
      //4、预算计划与执行季度趋势
      data4: [],
      option4: {
        grid: {
          width:475,
        },
        color:['rgba(11, 65, 205, 0.8)','rgba(11, 65, 205, 0.65)','rgba(11, 65, 205, 0.5)','rgba(11, 65, 205, 0.35)','rgba(45, 130, 240, 1)'],
        legend: {
          data: [{name:'已计划',icon: 'rect'}, {name:'已执行',icon: 'rect'}, {name:'待执行',icon: 'rect'},{name:'计划外',icon: 'rect'},{name:'已分配预算', lineStyle: {width:4},itemStyle: {opacity:0}}],
          left: 0,
          itemWidth: 8,
          itemHeight: 8
        },
        tooltip: {
          trigger: 'axis' ,
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          textStyle: {
            color: 'rgba(255, 255, 255, 1)',
          },
          padding: 0,
          formatter: this.quarterTrendFormater
        },
        xAxis: {
          type: 'category',
        },
        yAxis: {
          axisLabel: {
            formatter: this.formatLabelValue
          }
        },
        series: [
          {type:'bar',label:{show:false,formatter: this.formatChartValue}},
          {type:'bar',label:{show:false,formatter: this.formatChartValue},stack:'detail'},
          {type:'bar',label:{show:false,formatter: this.formatChartValue},stack:'detail'},
          {type:'bar',label:{show:false,formatter: this.formatChartValue},stack:'detail'},
          {type:'line',symbolSize:0,label:{show:false,formatter: this.formatChartValue,position:'top',color:'#000'}},
        ]
      },
      //5、预算计划与执行月度趋势
      data5: [],
      option5: {
        grid: {
          width:475,
        },
        color:['rgba(11, 65, 205, 0.65)','rgba(11, 65, 205, 0.5)','rgba(11, 65, 205, 0.35)','rgba(11, 65, 205, 0.8)'],
        legend: {
          data: [{name:'已执行',icon: 'rect'}, {name:'待执行',icon: 'rect'},{name:'计划外',icon: 'rect'},{name:'已计划', lineStyle: {width:4},itemStyle: {opacity:0}}],
          left: 0,
          itemWidth: 8,
          itemHeight: 8
        },
        tooltip: {
          trigger: 'axis' ,
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          textStyle: {
            color: 'rgba(255, 255, 255, 1)',
          },
          padding: 0,
          formatter: this.monthTrendFormater
        },
        xAxis: {type: 'category'},
        yAxis: {
          axisLabel: {
            formatter: this.formatLabelValue
          }
        },
        series: [
          {type:'bar',label:{show:false,formatter: this.formatChartValue},stack:'detail',name:'已执行',encode: {y: '已执行',x: '月度'}},
          {type:'bar',label:{show:false,formatter: this.formatChartValue},stack:'detail',name:'待执行',encode: {y: '待执行',x: '月度'}},
          {type:'bar',label:{show:false,formatter: this.formatChartValue},stack:'detail',name:'计划外',encode: {y: '计划外',x: '月度'}},
          {type:'line',symbolSize:0,label:{show:false,formatter: this.formatChartValue,position:'top',color:'#000'},name:'已计划',encode: {y: '已计划',x: '月度'}},
        ]
      },
    }
  },
  computed: {
    ...mapGetters(['userInfo','baseDataRecords','basedataGetName','basedataGetNameByRowIdField']),
    onlyBudgetPlan() {
      return this.searchMainData.meetingSystem || this.searchMainData.productIdList || this.searchMainData.costCenterList || this.searchMainData.wbsCodeList;
    }
  },
  watch: {
    'medicalFieldArr' (newVal, oldVal) {
      this.do(newVal, oldVal, 'medicalFieldArr');
    },
    'teamFieldArr' (newVal, oldVal) {
      this.do(newVal, oldVal, 'teamFieldArr');
    },
    'productIdArr' (newVal, oldVal) {
      this.do(newVal, oldVal, 'productIdArr');
    },
    'costCenterArr' (newVal, oldVal) {
      this.do(newVal, oldVal, 'costCenterArr');
    },
    'wbsCodeArr' (newVal, oldVal) {
      this.do(newVal, oldVal, 'wbsCodeArr');
    },
  },
  methods: {
    ...mapActions(['initBaseDataByTypes']),
    getMedicalFieldArray(departId, independ) {
      return orgUtil.franchiseArray(departId, independ);
    },
    getTeamArray(departId, medicalFieldArray, independ) {
      return orgUtil.teamArrayByArray(departId, medicalFieldArray, independ);
    },
    do(newVal, oldVal, field) {
      if (oldVal.indexOf('') >= 0 && (newVal.indexOf('') >= 0 && newVal.length > 1)) {
        this[field].splice(this[field].indexOf(''), 1);
      } else if ((oldVal.indexOf('') < 0 && newVal.indexOf('') >= 0) || newVal.length == 0) {
        this[field] = [''];
      }
    },
    progressFormater(params) {
      let str = '';
      str += params.seriesName + '<br/>'
      str += params.marker + params.name + ' : 　<span style="font-weight:bold">' + this.$formatMoney(this.$toThousand(params.value[params.seriesName],1,2)) + ' K</span>';
      return str;
    },
    quarterTrendFormater(params) {
      console.log(params)
      if(params.length > 0) {
        let quarter = params[0].axisValue;
        let str = `<div style="padding: 10px 10px 0 10px">第${quarter}</div>`;
        str += `<div style="display:flex;padding:5px 0;border-bottom:1px solid rgba(255, 255, 255, 0.15)"><span style="margin-left:10px;display:inline-block;margin-right:4px;margin-top:8px;width:6px;height:6px;background-color:rgba(255, 255, 255, 1);"></span><span style="margin-right:15px">已分配：${this.$formatMoney(this.$toThousand(params[0].value['已分配预算'],1,2))} K</span></div>`
        str += `<div style="display:flex;padding:5px 0;border-bottom:1px solid rgba(255, 255, 255, 0.15)"><span style="margin-left:10px;display:inline-block;margin-right:4px;margin-top:8px;width:6px;height:6px;background-color:rgba(255, 255, 255, 1);"></span><span style="margin-right:15px">已计划：${this.$formatMoney(this.$toThousand(params[0].value['已计划'],1,2))} K</span></div>`
        str += `<div style="display:flex;padding:5px 0;"><span style="margin-left:10px;display:inline-block;margin-right:4px;margin-top:8px;width:6px;height:6px;background-color:rgba(255, 255, 255, 1);"></span><span style="margin-right:15px">已执行：${this.$formatMoney(this.$toThousand(params[0].value['已执行'],1,2))} K</span></div>`
        str += `<div style="display:flex;padding:5px 0;border-bottom:1px solid rgba(255, 255, 255, 0.15)"><span style="margin-left:10px;display:inline-block;margin-right:4px;margin-top:8px;width:6px;height:6px;background-color:rgba(255, 255, 255, 1);"></span><span style="margin-right:15px">待执行：${this.$formatMoney(this.$toThousand(params[0].value['待执行'],1,2))} K</span></div>`
        str += `<div style="display:flex;padding:5px 0;"><span style="margin-left:10px;display:inline-block;margin-right:4px;margin-top:8px;width:6px;height:6px;background-color:rgba(255, 255, 255, 1);"></span><span style="margin-right:15px">计划外：${this.$formatMoney(this.$toThousand(params[0].value['计划外'],1,2))} K</span></div>`

        return str;
      }
    },
    monthTrendFormater(params) {
      console.log(params)
      if(params.length > 0) {
        let quarter = params[0].axisValue;
        let str = `<div style="padding: 10px 10px 0 10px">第${quarter}</div>`;
        str += `<div style="display:flex;padding:5px 0;border-bottom:1px solid rgba(255, 255, 255, 0.15)"><span style="margin-left:10px;display:inline-block;margin-right:4px;margin-top:8px;width:6px;height:6px;background-color:rgba(255, 255, 255, 1);"></span><span style="margin-right:15px">已计划：${this.$formatMoney(this.$toThousand(params[0].value['已计划'],1,2))} K</span></div>`
        str += `<div style="display:flex;padding:5px 0;"><span style="margin-left:10px;display:inline-block;margin-right:4px;margin-top:8px;width:6px;height:6px;background-color:rgba(255, 255, 255, 1);"></span><span style="margin-right:15px">已执行：${this.$formatMoney(this.$toThousand(params[0].value['已执行'],1,2))} K</span></div>`
        str += `<div style="display:flex;padding:5px 0;border-bottom:1px solid rgba(255, 255, 255, 0.15)"><span style="margin-left:10px;display:inline-block;margin-right:4px;margin-top:8px;width:6px;height:6px;background-color:rgba(255, 255, 255, 1);"></span><span style="margin-right:15px">待执行：${this.$formatMoney(this.$toThousand(params[0].value['待执行'],1,2))} K</span></div>`
        str += `<div style="display:flex;padding:5px 0;"><span style="margin-left:10px;display:inline-block;margin-right:4px;margin-top:8px;width:6px;height:6px;background-color:rgba(255, 255, 255, 1);"></span><span style="margin-right:15px">计划外：${this.$formatMoney(this.$toThousand(params[0].value['计划外'],1,2))} K</span></div>`

        return str;
      }
    },
    trimSpace(array) {
      for (let i = 0; i < array.length; i++) {
        //这里为过滤的值
        if (array.length > 1 && (array[i] == '' || array[i] == null || typeof (array[i]) == "undefined" || array[i] == ' ')) {
          array.splice(i, 1);
          i = i - 1;
        }
      }
      return array;
    },
    handleArrar4All(arrName) {
      if(this[arrName].length > 0 && this[arrName][this[arrName].length-1] == '') {
        this[arrName] = ['']
      }
    },
    handleMainSearch() {
      this.handleArrar4All('medicalFieldArr')
      this.handleArrar4All('teamFieldArr')
      this.handleArrar4All('productIdArr')
      this.handleArrar4All('costCenterArr')
      this.handleArrar4All('wbsCodeArr')

      this.searchMainData.medicalFieldList = this.trimSpace(JSON.parse(JSON.stringify(this.medicalFieldArr))).toString();
      this.searchMainData.teamFieldList = this.trimSpace(JSON.parse(JSON.stringify(this.teamFieldArr))).toString();
      this.searchMainData.productIdList = this.trimSpace(JSON.parse(JSON.stringify(this.productIdArr))).toString();
      this.searchMainData.costCenterList = this.trimSpace(JSON.parse(JSON.stringify(this.costCenterArr))).toString();
      this.searchMainData.wbsCodeList = this.trimSpace(JSON.parse(JSON.stringify(this.wbsCodeArr))).toString();
      dashboardApi.budget(this.searchMainData)
          .then(res => {
              res.YearBudgetDist['已分配预算'] = res.YearBudgetDist['已分配预算'].replace('%','')
              res.YearBudgetPlan['已分配预算'] = res.YearBudgetPlan['已分配预算'].replace('%','')
              this.data1Remain = 100 - parseFloat(res.YearBudgetDist['已分配预算']);
              this.data2Remain = 100 - parseFloat(res.YearBudgetPlan['已分配预算']);
             this.data1 = [res.YearBudgetDist];
             this.data2 = [res.YearBudgetPlan];
             res.BudgetPlanProgress['已执行金额'] = res.BudgetPlanProgress['已执行预算']
             delete res.BudgetPlanProgress['已执行预算']
             this.data3 = [res.BudgetPlanProgress];
             this.data4 = res.BudgetPlanSeasonTrend;
             this.data5 = res.BudgetPlanMonthTrend;
             this.option2.series[0].detail.color = parseFloat(res.YearBudgetPlan['已分配预算']) > 100?'#f00':'#333333';
             this.$nextTick(() => {
                this.$refs['chart1'].chartChange();
                this.$refs['chart2'].chartChange();
                this.$refs['chart3'].chartChange();
                this.$refs['chart4'].chartChange();
                this.$refs['chart5'].chartChange();
             });
          })
    },
    formatValue(params) {
        return params.seriesName+'：'+this.$formatMoney(this.$toThousand(params.value[params.seriesName],1,0)) + 'K';
    },
    formatLabelValue(value) {
        return this.$toThousand(value,1,0) + ' K';
    },
    formatChartValue(params) {
        return this.$toThousand(params.value[params.seriesName],1,0);
    },
  },
  mounted() {
    this.searchMainData.year = (new Date()).getFullYear();

    this.initBaseDataByTypes(['Depart','MedicalField','Product','Year', 'MeetingSystem', 'CostCenter','WbsCode'])
        .then(() => {
          this.handleMainSearch();
        })
  }
};
</script>

<style lang="less" scoped>
  .page-header {
    padding: 8px 0;
    margin-top: -24px;
    font-size: @breadcrumbCurrentFontSize;
    font-weight: bold;
    color: @contentFontColor;
    line-height: 32px;
    height: 48px;
    display: flex;
    align-items: center;

    &-title {
      font-weight: 400;
    }

    &-subinfo {
      height: 32px;
      line-height: 32px;
      margin-left: auto;
      font-weight: 400;
      font-size: 14px;
      color: #0B41CD;
      display: flex;

      i {
        margin-right: 8px;
      }

      &-role {
        width: 180px;

        label {
          margin-right: 10px;
          color: @contentFontColor;
        }

        div {
          width: 120px;
        }
      }
    }
  }
  .search-content-main {
    display: inline-block;
    margin-bottom: 6px;

    .search-content-main-fields {
      float:left;
      display: flex;

      .el-form-item + .el-form-item {
        margin-left: 16px;
      }

      &-year {
        width: 120px;
      }

      &-medicalField {
        width: 180px;
      }
      &-departId {
        width: 180px;
      }
    }
  }

  .charts-row {
    display: flex;

    .chart {
      height: 320px;
      width: 592px;
      background: #fff;

      .title {
        color: @subSubFontColor;
        font-size: 18px;
        margin: 15px 0 0 24px;

        i {
          font-size: 16px;
          margin-right: 6px;
          color: rgba(11, 65, 205, 0.5);
        }
      }
    }

    .chart-small {
      height: 280px;
      width: 288px;
    }

    .chart-small-long {
      height: 280px;
    }

    .chart-small-long2 {
      height: 280px;
      margin-left: 0px !important;
    }

    .chart + .chart {
      margin-left: 16px
    }
  }

  .charts-row + .charts-row {
    margin-top: 17px;
  }

  .gauge-legend {
    display: flex;
    margin: 16px 0 0 25px;
    font-size: 12px;
    color: @contentFontColor;

    &-value {
      display: flex;
      margin-right: 12px;
      div{
        height: 9px;
        width: 9px;
        border-radius: 4.5px;
        margin: 2px 8px 0 0;
      }
    }

    &-value-1 {
      div {
        background-color: #2D82F0;
      }
    }

    &-value-2 {
      div {
        background-color: #E8EAEC;
      }
    }

    &-value-3 {
      div {
        background-color: #0B41CD;
      }
    }
  }

  .axis-label {
    height: 0px;
    &-0 {
      position: relative;
      top: 145px;
      left: 75px;
      font-size: 14px;
      color: rgba(0,0,0,0.45);
    }
    &-100 {
      position: relative;
      top: 145px;
      left: 195px;
      font-size: 14px;
      color: rgba(0,0,0,0.45);
    }
    &-remain {
      position: relative;
      top: 115px;
      left: 170px;
      font-size: 16px;
      color: #333333;
      font-weight: bold;
      width: 36px;
    }
  }

  .axis-label-long {
    margin-left: 152px;
  }

  .message-info {
    margin-top: -35px;
    display: flex;
    height: 40px;
    font-size: 12px;
    color: @subFontColor;
    line-height: 20px;
    div {
      margin: 0 auto;
    }
  }

</style>

<style lang="less">
.search-content-main-fields{
  .el-tag--info {
    max-width: 140px;
    min-width: 45px;
    padding-right: 15px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    position: relative;
    .el-tag__close{
      position: absolute;
      right: -1px;
      top: 5px;
    }
  }
}
  .dashboard-budget {
      .chart-class-1,.chart-class-2 {
          margin: 0px auto;
          width: 200px;
          height: 200px;
      }

      .chart-class-3 {
          margin: 16px 24px;
          width: 544px;
          height: 240px;
      }

      .chart-class-4, .chart-class-5 {
          margin-top: 15px;
          margin-left: auto;
          width: 572px;
          height: 280px;
      }
  }
</style>



// WEBPACK FOOTER //
// index-old.vue?c22472ca